import React from 'react';
import { InfoIcon } from '../Icons';
import { TextHint } from '../Hint';
import * as Ui from './styles';

function InfoBadge({
  /**
   * info text
   */
  toolTipText = null,
  /**
   * others props
   */
  ...props
}) {
  // from theme or parent style
  const { className, theme } = props;

  /**
   * render info badge
   */
  function renderIcon() {
    return (<InfoIcon size={20} theme={theme} />);
  }

  return (
    <Ui.Container className={className} theme={theme}>
      {toolTipText ? (
        <TextHint tooltip={toolTipText}>
          {renderIcon()}
        </TextHint>
      ) : renderIcon()}
    </Ui.Container>
  );
}

export { InfoBadge };
export default InfoBadge;
